import { Injectable } from '@angular/core';
import {
  FulfillmentFormConfigInterface,
  FulfillmentFormSubmissionApiService,
  FulfillmentFormSubmissionInterface,
  GetLatestFulfillmentFormSubmissionRequest,
  GetLatestFulfillmentFormSubmissionResponseInterface,
} from '@vendasta/order-fulfillment';
import {
  FulfillmentOrderConfigApiService,
  ReleaseType,
  GetFulfillmentOrderConfigRequest,
} from '@vendasta/marketplace-apps';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { SSOService } from '@vendasta/sso';
import { productUsesDynamicWorkOrder } from './external-form-products';

@Injectable({
  providedIn: 'root',
})
export class WorkOrderFormConfigService {
  constructor(
    private formSubmissionService: FulfillmentFormSubmissionApiService,
    private formConfigService: FulfillmentOrderConfigApiService,
    private ssoService: SSOService,
  ) {}
  getFormConfig(salesOrderId: string, appId: string, businessId: string): Observable<FulfillmentFormConfigInterface> {
    return this.formSubmissionService
      .getLatestFulfillmentFormSubmission(
        new GetLatestFulfillmentFormSubmissionRequest({
          salesOrderId: salesOrderId,
          appId: appId,
          businessId: businessId,
        }),
      )
      .pipe(
        map((response) => response.fulfillmentFormSubmission.formConfig),
        catchError((err) => {
          if (err.status === 404) {
            return this.formConfigService
              .getFulfillmentOrderConfig(
                new GetFulfillmentOrderConfigRequest({
                  appId: appId,
                  release: ReleaseType.RELEASE_TYPE_PUBLISHED,
                  projectionFilter: { includeFormConfig: true },
                }),
              )
              .pipe(map((response) => response.config?.fulfillmentForm as FulfillmentFormConfigInterface));
          } else {
            throw err;
          }
        }),
        map((config) => this.injectSSOUrl(appId, businessId, config)),
      );
  }

  getLatestSubmission(
    salesOrderId: string,
    appId: string,
    businessId: string,
  ): Observable<FulfillmentFormSubmissionInterface> {
    return this.formSubmissionService
      .getLatestFulfillmentFormSubmission(
        new GetLatestFulfillmentFormSubmissionRequest({
          salesOrderId: salesOrderId,
          appId: appId,
          businessId: businessId,
        }),
      )
      .pipe(
        catchError(() => of({} as GetLatestFulfillmentFormSubmissionResponseInterface)),
        map((resp) => resp?.fulfillmentFormSubmission || {}),
      );
  }

  // QOF-2072: Custom work to redirect to Matchcraft order form by linking to SSO urls in a fulfillment form
  private injectSSOUrl(
    appId: string,
    businessId: string,
    config: FulfillmentFormConfigInterface,
  ): FulfillmentFormConfigInterface {
    if (productUsesDynamicWorkOrder(appId)) {
      for (let i = 0; i < config.orderForm.length; i++) {
        if (config.orderForm[i].type === 'checkbox') {
          const ssoUrl = this.ssoService.getServiceGatewayURLForAccount(appId, businessId);
          config.orderForm[i].label =
            `I have completed the <a href="${ssoUrl}" target="_blank">external order form</a> for this product`;
          return config;
        }
      }
    }
    return config;
  }
}
